/**
 * Returns array of card IDs, sorted by card title
 * @param {Object} cards
 * @param {Array} list
 */
const sortByTitle = (cards, list) => {
  const sortedList = [...list];
  return sortedList.sort((a, b) => {
    const aTitle = cards[a] ? cards[a].title || 'zz' : 'zz';
    const bTitle = cards[b] ? cards[b].title || 'zz' : 'zz';
    if (aTitle < bTitle) {
      return -1;
    }
    if (aTitle > bTitle) {
      return 1;
    }
    return 0;
  });
};

/**
 * Returns random ID from array
 * @param {Array} set - Set of IDs
 * @return {String} - ID string or undefined
 */
const getRandomId = set => {
  const randomIndex = Math.floor(Math.random() * set.length);
  return set[randomIndex];
};

/**
 * Returns new array with no items from previous array, or repeats
 * If not enough items in all, will include repeats
 * @param {Array} previous - Previous version of array
 * @param {Arry} all - All possible items
 * @return {Array}
 */
const getNewArrayNoRepeats = (previous = [], all = [], targetLength = 0) => {
  if (!all.length) return [];
  const notEnoughItems = all.length < previous.length + targetLength;

  const usedItems = previous.reduce((obj, item) => ({ ...obj, [item]: true }), {});
  const newArr = [];

  while (newArr.length < (targetLength || previous.length)) {
    const newId = getRandomId(all);
    if (!usedItems[newId] || notEnoughItems) {
      newArr.push(newId);
      usedItems[newId] = true;
    }
  }
  return newArr;
};

// ** No longer using ** - just generating single random id each day
// Daily cards should be shuffled in a way that
// doesn't lead to getting the same card within a few days
// percentBetween = minimum percent of indexes between the same card if the two arrays were combined

// const shuffleDailyCards = (originalArray) => {
//   const array = [...originalArray];
//   const percentBetween = 0.4;
//   const numBetween = Math.floor(array.length * percentBetween);
//   for (let i = 0; i < array.length - 2; i++) {
//     const maxLength = (array.length) - Math.max(numBetween - i, 0);
//     const randomIndex = Math.floor((Math.random() * (maxLength - i)) + i);
//     const temp = array[i];
//     array[i] = array[randomIndex];
//     array[randomIndex] = temp;
//   }
//   return array;
// };

export { sortByTitle, getRandomId, getNewArrayNoRepeats };
